module.exports = __webpack_public_path__ + "static/logo-6a3edd35c6a535c5531410129fec092e.png";